module.exports = __webpack_public_path__ + "static/downtown-publishing-9c88bc407d58e937b68d58127ab1b28f.png";